/* eslint-disable no-useless-escape */
import { get } from "@/utils";
import store from "../../store";
import MobileDetect from "mobile-detect";
import { nombresPaquetes } from "@/config/constants/packagesCodes";

/**
 * Obtejer categoría para el pixel de acuerdo al paquete
 * @param {Object} caracteristicasPaquete
 */
export const _getCategoria = caracteristicasPaquete => {
  let tipoPaquete = caracteristicasPaquete.tipoPaquete;
  // Devolver nombre de paquete
  return nombresPaquetes(tipoPaquete);
};

/**
 * Verificar por el userAgent si el dispositivo es
 * mobile o no
 */
export const _isMobile = () => {
  const md = new MobileDetect(window.navigator.userAgent);
  return md.mobile() !== null;
};

/**
 * Verificar si estamos en presencia de cierto CID en la URL para disparar el pixel
 * (o una callback en general)
 * @param cid Array | String
 * @param cb function
 */
export const matchesTCode = (cid, cb) => {
  let current_cid = store.getters.getTCode();
  // El cid puede ser string o array
  if (typeof cid === "string") {
    cid = [cid];
  }

  for (const c of cid) {
    if (
      current_cid &&
      (current_cid + "").toLowerCase().includes(c.toLowerCase())
    ) {
      if (cb && typeof cb === "function") {
        return cb();
      }
    }
  }
};

export const _normalizeCharacters = str => {
  return str
    ? (str + "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
    : str;
};

export const _normalizeCurrency = currency => {
  // Algunos valores de moneda (dolares) vienen de backend
  // con un código no estandar
  currency = currency ? (currency + "").toLowerCase() : "";
  let mapping = {
    dol: "USD"
  };

  return get(mapping, currency, currency).toUpperCase();
};

export const _normalizeGender = gender => {
  // Normalizar género
  gender = gender ? (gender + "").toLowerCase() : "";
  let mapping = {
    m: "masculino",
    f: "femenino"
  };

  return get(mapping, gender, gender);
};

/**
 * Helpers para etiquetados de circuitos
 * @warning: MODIFICAR también los duplicados en src/digitalData.js
 */
export const getGlobalApplication = () => {
  const globalApplications = {
    ofertaCGU: "doble play",
    ofertaNomina: "onboarding payroll",
    ofertaCajaAhorro: "doble play",
    ofertaEmprendedores: "doble play"
  };
  return globalApplications[_BBVA_MOTOR] || "onboarding payroll";
};

export const getApplicationName = () => {
  const globalApplications = {
    ofertaCGU: "doble play",
    ofertaNomina: "circuito nominas",
    ofertaCajaAhorro: "doble play",
    ofertaEmprendedores: "doble play"
  };
  return globalApplications[_BBVA_MOTOR] || "circuito nominas";
};

export const getFulfillmentModel = () => {
  const globalApplications = {
    ofertaCGU: "online",
    ofertaNomina: "offline",
    ofertaCajaAhorro: "online",
    ofertaEmprendedores: "online"
  };
  return globalApplications[_BBVA_MOTOR] || "offline";
};

export const getTypology = () => {
  const typologys = {
    ofertaCGU: "cuenta gratuita universal",
    ofertaNomina: "caja de ahorro nominas",
    ofertaCajaAhorro: "caja de ahorro tradicional",
    ofertaEmprendedores: "caja de ahorro openpay"
  };
  return typologys[_BBVA_MOTOR] || "caja de ahorro nominas";
};

export const getOffer = context => {
  const camino = get(context, "state.dataQuery.camino", null);
  const procesess = {
    1: "caja de ahorro",
    2: "oferta paquete",
    3: "en base nominas",
    4: "no esta en base",
    5: "con ca existente"
  };
  return camino ? procesess[camino] : "";
};
